export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-Cyrillic-3805bfb39f70472f930769bda1d1d448.woff";